<template>
  <div>

    <b-tabs v-model="tabIndex" :card="false" :vertical="false" :end="false" align="center"  nav-wrapper-class="d-none">
    <b-tab ref="datenTab">
    <template #title>
       <button type="button" class="btn" aria-label="Left Align">
        <div class="icon-profile cutterkollegen-id-badge"></div>
        <span class="small-font">Daten</span>
       </button>
    </template>
    <p class="p-md-3"><Daten ref="Daten" :user="user" :profil="profil"/></p>
    </b-tab>

    <b-tab ref="adminTab" v-if="hasRoles(['Admin','Disponent'])">
    <template #title>
      <button type="button" class="btn" aria-label="Left Align">
        <div class="icon-profile cutterkollegen-user-cog"></div>
        <div class="small-font">Administrativ</div>
       </button>
    </template>
    <p class="p-md-3"><Administrativ ref="Administrativ" :user="user" :profil="profil"/></p>
    </b-tab>

    <b-tab ref="erfahrungTab" v-if="hasRoles(['Admin','Disponent','Cutter'])">
    <template #title>
      <button type="button" class="btn" aria-label="Left Align">
        <div class="icon-profile cutterkollegen-list"></div>
        <span class="small-font">Erfahrung</span>
       </button>
    </template>
    <p class="p-md-3"><Erfahrung ref="Erfahrung" :user="user" :profil="profil"/></p>
    </b-tab>

    <b-tab ref="filmTab" v-if="hasRoles(['Admin','Disponent','Mitglied'])">
    <template #title>
      <button type="button" class="btn" aria-label="Left Align">
        <div class="icon-profile cutterkollegen-clapperboard"></div>
        <span class="small-font">Filmografie</span>
       </button>
    </template>
    <p class="p-md-3"><Filmografie ref="Filmografie" :user="user" :profil="profil"/></p>
    </b-tab>

    <b-tab ref="kundenTab" v-if="hasRoles(['Admin','Disponent','Mitglied'])">
    <template #title>
      <button type="button" class="btn" aria-label="Left Align">
        <div class="icon-profile cutterkollegen-customer"></div>
        <span class="small-font">Kunden</span>
       </button>
    </template>
    <p class="p-md-3"><Kunden ref="Kunden" :user="user" :profil="profil"/></p>
    </b-tab>

    <b-tab ref="sendungenTab" v-if="hasRoles(['Admin','Disponent','Mitglied'])">
    <template #title>
      <button type="button" class="btn" aria-label="Left Align">
        <div class="icon-profile cutterkollegen-tv"></div>
        <span class="small-font">Sendungen</span>
       </button>
    </template>
    <p class="p-md-3"><Sendungen ref="Sendungen" :user="user" :profil="profil"/></p>
    </b-tab>

    </b-tabs>
  </div>
</template>
<script>
import Daten from './profil/Daten'
import Administrativ from './profil/Administrativ'
import Erfahrung from './profil/Erfahrung'
import Filmografie from './profil/Filmografie'
import Kunden from './profil/Kunden'
import Sendungen from './profil/Sendungen'
import utils from '@/utilities'
import api from '@/api/benutzer'
import store from '@/store'

export default {
  props: ['user', 'profil'],
  methods: {
    hasRoles (roles) {
      // make sure to take the roles from the token, as normal user doent have the roles in the user object
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), roles)
    }
  },
  async mounted () {
    let that = this
    this.$root.$on('activate-profil-tab', (id) => {
      if (that.$refs[id]) {
        that.$refs[id].activate()
      }
    })
    if (this.user.id === this.localUser.id) {
      const baseData = await api.refresh()
      if (baseData) {
        store.dispatch('setBaseData', baseData)
      }
    }
  },
  computed: {
    isProfil () {
      return this.profil === 'true'
    },
    editMode () {
      return this.isProfil()
    }
  },
  components: {
    Daten, Administrativ, Erfahrung, Filmografie, Kunden, Sendungen
  },
  name: 'Profil',
  data () {
    return {
      tabIndex: 0,
      localUser: this.$store.state.auth.user
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Profil.vue